import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { SectionBadge } from '../SectionBadge';
import { Reveal } from '../Reveal';
import { JOURNEY } from '../../data/content';
const STAGE_STYLES = ['bg-cream-deep text-cocoa-soft', 'bg-terra-soft text-cocoa', 'bg-terra text-cream'];
export function ProductIntro() {
  return <section className="w-full px-5 py-14 sm:py-20" data-id="element-199" data-mp="2ag50ths79fdq">
      <div className="mx-auto max-w-5xl" data-id="element-200" data-mp="2pe72tnjl1ssv">
        <Reveal className="text-center" data-id="element-201" data-mp="2pcw1rvhiuz5g">
          <SectionBadge data-id="element-202" data-mp="2pbug6x2vqu9h">La solución</SectionBadge>
          <h2 className="mx-auto mt-5 max-w-3xl font-display text-3xl leading-tight text-cocoa sm:text-5xl" data-id="element-203" data-mp="2ke1by9l50abu">
            Por eso creamos el <span className="italic text-terra" data-id="element-204" data-mp="2y5pi7w8pg4kw">Megapack Bolsos Crochet Pro</span>
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-cocoa-soft sm:text-base" data-id="element-205" data-mp="2u5p64i92w5h0">
            Un sistema digital pensado para ayudarte a pasar de la idea al bolso terminado.
          </p>
        </Reveal>

        <ol className="mt-10 grid items-stretch gap-3 md:grid-cols-[1fr_auto_1fr_auto_1fr]" data-id="element-206" data-mp="333r5yuh2ss2p">
          {JOURNEY.map((stage, index) => <React.Fragment key={stage.label} data-id="element-207" data-mp="2l3ymt5afwypx" data-mpi={index}>
              <Reveal as="li" delay={index * 80} className="list-none" data-id="element-208" data-mp="2l4qj6ibv30h9">
                <div className={`flex h-full flex-col rounded-2xl p-5 sm:p-7 ${STAGE_STYLES[index]}`} data-id="element-209" data-mp="2q2i6t05h40fn">
                  <span className="text-[11px] font-extrabold uppercase tracking-[0.18em] opacity-80" data-id="element-210" data-mp="2u5y47ypda4te">
                    {stage.label}
                  </span>
                  <p className="mt-3 font-display text-2xl italic leading-snug sm:text-[28px]" data-id="element-211" data-mp="3432ua9mc2kfh">“{stage.quote}”</p>
                </div>
              </Reveal>
              {index < JOURNEY.length - 1 && <li aria-hidden="true" className="hidden list-none items-center justify-center md:flex" data-id="element-212" data-mp="3dt5tirk1sum9">
                  <ArrowRightIcon className="h-5 w-5 text-terra" data-id="element-213" data-mp="3hv0ufuy2h5zi" />
                </li>}
            </React.Fragment>)}
        </ol>
      </div>
    </section>;
}